import { useField } from 'formik'
import { Suspense } from 'react'
import { Dropdown } from 'src/components/Forms'
import FieldSuspense from 'src/components/Forms/FieldSuspense'
import { useDistributionsByPositionId } from 'src/queries'

interface DistributionsProps {
  positionId?: number
}

interface DistributionDropdownProps {
  positionId?: number
}

const DistributionDropdown: React.FC<DistributionDropdownProps> = (props) => {
  const { positionId } = props
  const distributions = useDistributionsByPositionId(positionId)
  return (
    <Dropdown
      name='distribution' label='Distribution' options={distributions.map((d) => {
        return { value: d._id, label: `${d._subcategory?.name ?? ''} (${d._category?.name ?? ''})` }
      })}
    />
  )
}

const Distributions: React.FC<DistributionsProps> = (props) => {
  const [position] = useField('position')

  const positionId = parseInt(position.value)

  return (
    <Suspense fallback={<FieldSuspense label='Distribution' />}>
      <DistributionDropdown positionId={positionId} />
    </Suspense>
  )
}

export default Distributions
